import { useI18n } from '@react/i18n';
import { PrintLabel, translateLabel } from '../PrintLabel';
import { TypVraceni } from '../types';

interface Props {
    typVraceni: TypVraceni;
    stitekInfo: string;
    language: string;
}

/** Instruktážní fotky balení – jen jazyky, pro které existují (parita s legacy) */
function instructionImage(language: string, typVraceni: TypVraceni): string | null {
    if (language === 'en') {
        return typVraceni === 'vratka' ? '/images/vratky/return_en.jpg' : '/images/vratky/claim_en.jpg';
    }
    if (language === 'cs') {
        return typVraceni === 'vratka' ? '/images/vratky/return_cz.jpg' : '/images/vratky/claim_cz.jpg';
    }
    if (language === 'sk') {
        return typVraceni === 'vratka' ? '/images/vratky/return_cz.jpg' : '/images/vratky/claim_sk.jpg';
    }
    return null;
}

export function Finished({ typVraceni, stitekInfo, language }: Props) {
    const t = useI18n();
    const label = translateLabel(stitekInfo, language);
    const image = instructionImage(language, typVraceni);

    return (
        <div className="vr-step">
            <h3>{typVraceni === 'vratka' ? t('Vratka byla vytvořena.') : t('Reklamace byla vytvořena.')}</h3>

            <div className="vr-alert vr-alert--info vr-finished">
                <strong>{t('Prosím zašlete či doručte balík na adresu:')}</strong>
                <address className="vr-finished__address">
                    BOLA spol s.r.o.<br />
                    Severní 276<br />
                    252 25 Jinočany<br />
                    Czech Republic
                </address>
                <strong>{t('Pokud po vás dopravce požaduje telefonní číslo, uveďte +420 778 710 207.')}</strong>
                <p>
                    <strong>{t('Vepište na štítek/balík:')}</strong><br />
                    <strong className="vr-finished__label">{label}</strong>
                </p>
                <strong>{t('Produkt ponechte v originální krabičce a tu zabalte do přepravní krabice (aby se nepoškodila krabice produktu).')}</strong>
                {image && <img className="vr-finished__image" alt="" src={image} />}
            </div>

            <div className="vr-card vr-print-card">
                <PrintLabel stitekInfo={label} />
                <button type="button" className="vr-btn vr-btn--primary" onClick={() => window.print()}>
                    {t('Vytisknout štítek na balík')}
                </button>
            </div>
        </div>
    );
}
